import { notifyParent } from 'mailup-react-helpers'
import { Loading, ToastContainer, Tooltip } from 'mailup-web-components'
import BeePluginEditor from 'Pages/MessageEdit/BeePluginEditor/BeePluginEditor'
import ErrorFeedback from 'Pages/MessageEdit/ErrorFeedback'
import Header from 'Pages/MessageEdit/Header'
import { ModalConcurrentAccess } from 'Pages/MessageEdit/ModalConcurrentAccess/ModalConcurrentAccess'
import { ModalConfirmLeave } from 'Pages/MessageEdit/ModalConfirmLeave'
import { ModalPreview } from 'Pages/MessageEdit/ModalPreview/ModalPreview'
import { ModalResumeAutoSave } from 'Pages/MessageEdit/ModalResumeAutoSave/ModalResumeAutoSave'
import { ModalThirdParty } from 'Pages/MessageEdit/ModalThirdParty'
import {
  cleanupPageCallback,
  getTotalTokensCountCallback
} from 'Pages/MessageEdit/recoil/callbacks/callbacks'
import { pageErrorState, pageState } from 'Pages/MessageEdit/recoil/state/page'
import { previewState } from 'Pages/MessageEdit/recoil/state/preview'
import { useEffect } from 'react'
import { useRecoilCallback, useRecoilValue, useResetRecoilState } from 'recoil'
import ModalSaveAsTemplate from './ModalSaveAsTemplate'

import { ModalConfirmEnableNotification } from 'Pages/MessageEdit/ModalConfirmEnableNotification'
import ModalError from 'Pages/MessageEdit/ModalError/ModalError'
import { ModalSave } from 'Pages/MessageEdit/ModalSave/ModalSave'
import ModalBeeContentDialog from './ModalBeeContentDialog'
import ModalConfirmExit from './ModalConfirmExit'
import Preview from './Preview'

import ModalAiAssistantBee from 'Components/ModalAiAssistantBee'
import ModalContentDefaults from 'Components/ModalContentDefaults/ModalContentDefaults'
import ModalOfferLightUpsell from 'Components/ModalOfferLightUpsell'
import { modalOfferLightUpsellState } from 'Pages/MessageEdit/recoil/state/modals'
import { ModalBeeSavedRow } from './ModalBeeSavedRow/ModalBeeSavedRow'
import { openAIState } from './recoil/state/editor'

const MessageEdit = () => {
  const { loading } = useRecoilValue(pageState)
  const { error } = useRecoilValue(pageErrorState)
  const { active: previewActive } = useRecoilValue(previewState)
  const cleanup = useRecoilCallback(cleanupPageCallback, [])
  const { showBuy } = useRecoilValue(openAIState)
  const getTotalTokensCount = useRecoilCallback(getTotalTokensCountCallback, [])
  const { show: showModalOfferLightUpsell } = useRecoilValue(
    modalOfferLightUpsellState
  )
  const closeModalOfferLightUpsell = useResetRecoilState(
    modalOfferLightUpsellState
  )

  useEffect(() => {
    notifyParent('setFullScreen', [true])
    getTotalTokensCount()
    return () => {
      cleanup()
      notifyParent('setFullScreen', [false])
    }
  }, [])

  return (
    <>
      <Loading open={loading} />
      <Header />
      <ToastContainer />
      <Tooltip />
      <ModalThirdParty />
      <ModalResumeAutoSave />
      <ModalConcurrentAccess />
      <ModalSaveAsTemplate />
      <ModalPreview />
      <ModalBeeContentDialog />
      <ModalError />
      <ModalConfirmLeave />
      <ModalConfirmExit />
      <ModalSave />
      <ModalConfirmEnableNotification />
      <ModalBeeSavedRow />
      <ModalContentDefaults />
      <ModalAiAssistantBee showBuy={showBuy} />
      <ModalOfferLightUpsell
        show={showModalOfferLightUpsell}
        onClose={closeModalOfferLightUpsell}
      />

      <div className='l-container'>
        <ErrorFeedback />
      </div>

      <div style={!previewActive ? { display: 'none' } : undefined}>
        <Preview />
      </div>
      {!error && (
        <div style={previewActive ? { display: 'none' } : undefined}>
          <BeePluginEditor />
        </div>
      )}
    </>
  )
}

export default MessageEdit
